import styled from "styled-components";

const SubTitleContainer = styled.div`
  position: relative;
  display: flex;
  align-items: flex-end;
  gap: 10px;
  margin-top: 120px;
  margin-bottom: 34px;
  color: var(--primary-c);
  font-weight: 700;
  animation: fadeInDown 1.5s forwards;

  @keyframes fadeInDown {
    from {
      opacity: 0;
      transform: translateY(-30px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  h3 {  
    font-size: 22px;

    /* @media (max-width: 1400px) {
      font-size: calc( 5rem  * 0.78);
    } */
  }

  span {
    font-size:3rem;
  }

  ::before {
    position: absolute;
    left: 0px;
    bottom: calc(100% + 15px);
    content: "";
    display: block;
    width: 40px;
    height: 5px;
    background-color: #5293BB;
  }
`;


export default function SubTitle({ title, subTitle }) {
  return (
    <>
      <SubTitleContainer>
        <h3>{title}</h3>
        {subTitle && <span>&gt; {subTitle}</span>}
      </SubTitleContainer>
    </>
  );
};

